//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var script = {
  props: {
    /**
     * Total no. of pages
     */
    totalPages: {
      type: Number,
    },
    /**
     * Sets the current page. Pages start at 1.
     */
    currentPage: {
      type: Number,
      default: 1,
      validator: function (value) {
        return value > 0;
      },
    },
    /**
     * Sets the number of pages that appear before and after active page
     * between gap indicator
     */
    pagePadding: {
      type: Number,
      default: 1,
      validator: function (value) {
        return value > 0;
      },
    },
    /**
     * Positions the leading and trailing gap indicator, based on
     * the current and total pages
     */
    pageGap: {
      type: Number,
      default: 2,
      validator: function (value) {
        return value > 0;
      },
    },
    /**
     * Hide prev and next button on reaching first or last page
     */
    hidePrevNext: {
      type: Boolean,
      default: false,
    },
  },

  data: function data() {
    return {
      internalPage: this.currentPage,
    };
  },

  computed: {
    renderPages: function renderPages() {
      var pages = [];
      var PADDING = this.pagePadding;
      var GAP = this.pageGap;

      for (var pageIndex = 1; pageIndex <= this.totalPages; pageIndex++) {
        // Always display current, first, and last pages
        if (pageIndex === this.internalPage || pageIndex < GAP || pageIndex > this.totalPages - GAP + 1) {
          pages.push(this.createPage(pageIndex));
          continue;
        }

        var minimum = (void 0);
        var maximum = (void 0);

        if (this.internalPage <= GAP + PADDING) {
          minimum = GAP + 1;
          maximum = minimum + PADDING * 2;
        } else if (this.internalPage >= this.totalPages - GAP - PADDING) {
          maximum = this.totalPages - GAP;
          minimum = maximum - PADDING * 2;
        } else {
          minimum = this.internalPage - PADDING;
          maximum = this.internalPage + PADDING;
        }

        // Display padded window of pages
        if (
          (pageIndex >= minimum && pageIndex <= this.internalPage) ||
          (pageIndex >= this.internalPage && pageIndex <= maximum)
        ) {
          pages.push(this.createPage(pageIndex));
          continue;
        }

        // Handle start gap
        if (pageIndex === GAP) {
          if (minimum > GAP + 1 && this.internalPage > GAP + PADDING + 1) {
            pages.push(this.createGap(pageIndex));
          } else {
            pages.push(this.createPage(pageIndex));
          }

          continue;
        }

        // Handle end gap
        if (pageIndex === this.totalPages - GAP + 1) {
          if (maximum < this.totalPages - GAP && this.internalPage < this.totalPages - GAP - PADDING) {
            pages.push(this.createGap(pageIndex));
          } else {
            pages.push(this.createPage(pageIndex));
          }

          continue;
        }
      }
      return pages;
    },
  },

  watch: {
    currentPage: function currentPage(value) {
      this.internalPage = value;
    },
  },

  methods: {
    /**
     * Create object for page and return
     * @param {Number} pageIndex
     * @returns {Object}
     */
    createPage: function createPage(pageIndex) {
      return {
        key: pageIndex,
        current: this.internalPage === pageIndex,
        value: pageIndex,
      };
    },

    /**
     * Create object for gap in page and return
     * @param {Number} pageIndex
     * @returns {Object}
     */
    createGap: function createGap(pageIndex) {
      return {
        key: pageIndex,
        isGap: true,
      };
    },

    /**
     * Returns boolean if first page
     * @returns {Boolean}
     */
    firstPageSelected: function firstPageSelected() {
      return this.internalPage === 1;
    },

    /**
     * Returns boolean if last page
     * @returns {Boolean}
     */
    lastPageSelected: function lastPageSelected() {
      return this.internalPage === this.totalPages || this.totalPages === 0;
    },

    /**
     * click handler for left and right arrows
     * @param {Boolean} isNext
     */
    moveToPage: function moveToPage(isNext) {
      if (isNext && this.internalPage !== this.totalPages) {
        this.setPage(this.internalPage + 1);
      }
      if (!isNext && this.internalPage !== 1) {
        this.setPage(this.internalPage - 1);
      }
    },

    /**
     * Emit page on change
     * @params {Number}
     */
    setPage: function setPage(page) {
      this.internalPage = page;
      this.$emit('change', page);
    },
  },
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
        createInjectorSSR = createInjector;
        createInjector = shadowMode;
        shadowMode = false;
    }
    // Vue.extend constructor export interop.
    var options = typeof script === 'function' ? script.options : script;
    // render functions
    if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    var hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (style) {
                style.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (style) {
        hook = shadowMode
            ? function (context) {
                style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
            }
            : function (context) {
                style.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            var originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            var existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return script;
}

var isOldIE = typeof navigator !== 'undefined' &&
    /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());
function createInjector(context) {
    return function (id, style) { return addStyle(id, style); };
}
var HEAD;
var styles = {};
function addStyle(id, css) {
    var group = isOldIE ? css.media || 'default' : id;
    var style = styles[group] || (styles[group] = { ids: new Set(), styles: [] });
    if (!style.ids.has(id)) {
        style.ids.add(id);
        var code = css.source;
        if (css.map) {
            // https://developer.chrome.com/devtools/docs/javascript-debugging
            // this makes source maps inside style tags work properly in Chrome
            code += '\n/*# sourceURL=' + css.map.sources[0] + ' */';
            // http://stackoverflow.com/a/26603875
            code +=
                '\n/*# sourceMappingURL=data:application/json;base64,' +
                    btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
                    ' */';
        }
        if (!style.element) {
            style.element = document.createElement('style');
            style.element.type = 'text/css';
            if (css.media)
                { style.element.setAttribute('media', css.media); }
            if (HEAD === undefined) {
                HEAD = document.head || document.getElementsByTagName('head')[0];
            }
            HEAD.appendChild(style.element);
        }
        if ('styleSheet' in style.element) {
            style.styles.push(code);
            style.element.styleSheet.cssText = style.styles
                .filter(Boolean)
                .join('\n');
        }
        else {
            var index = style.ids.size - 1;
            var textNode = document.createTextNode(code);
            var nodes = style.element.childNodes;
            if (nodes[index])
                { style.element.removeChild(nodes[index]); }
            if (nodes.length)
                { style.element.insertBefore(textNode, nodes[index]); }
            else
                { style.element.appendChild(textNode); }
        }
    }
}

/* script */
var __vue_script__ = script;

/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "nav",
    { attrs: { role: "navigation", "aria-label": "Pagination Navigation" } },
    [
      _c(
        "ul",
        { staticClass: "vs-pagination" },
        [
          _c(
            "li",
            {
              class: [
                { "vs-pagination--disabled": _vm.firstPageSelected() },
                ,
                {
                  "vs-pagination--no-cursor":
                    !_vm.hidePrevNext && _vm.firstPageSelected()
                }
              ]
            },
            [
              _c(
                "a",
                {
                  attrs: {
                    tabindex:
                      !_vm.hidePrevNext && _vm.firstPageSelected() ? -1 : 0,
                    "aria-label": "Previous Page"
                  },
                  on: {
                    click: function($event) {
                      return _vm.moveToPage(false)
                    },
                    keyup: function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      return _vm.moveToPage(false)
                    }
                  }
                },
                [
                  !(_vm.hidePrevNext && _vm.firstPageSelected())
                    ? _vm._t("leftIcon", [
                        _c(
                          "svg",
                          {
                            attrs: {
                              xmlns: "http://www.w3.org/2000/svg",
                              width: "16",
                              height: "16",
                              viewBox: "0 0 16 16",
                              focusable: "false",
                              role: "presentation"
                            }
                          },
                          [
                            _c("path", {
                              attrs: {
                                fill: "currentColor",
                                d:
                                  "M10.39 12.688a.5.5 0 01-.718.69l-.062-.066-4-5a.5.5 0 01-.054-.542l.054-.082 4-5a.5.5 0 01.83.55l-.05.074L6.641 8l3.75 4.688z"
                              }
                            })
                          ]
                        )
                      ])
                    : _vm._e()
                ],
                2
              )
            ]
          ),
          _vm._v(" "),
          _vm._l(_vm.renderPages, function(page) {
            return [
              page.isGap
                ? [
                    _c(
                      "li",
                      { key: page.key, staticClass: "vs-pagination--gap" },
                      [_c("a", [_vm._v("...")])]
                    )
                  ]
                : [
                    _c(
                      "li",
                      {
                        key: page.key,
                        class: { "vs-pagination--active": page.current }
                      },
                      [
                        _c(
                          "a",
                          {
                            attrs: {
                              tabindex: "0",
                              "aria-current": page.current ? "true" : "false",
                              "aria-label": page.current
                                ? "Current page, Page " + page.value
                                : "Goto Page " + page.value
                            },
                            on: {
                              click: function($event) {
                                return _vm.setPage(page.value)
                              },
                              keyup: function($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.setPage(page.value)
                              }
                            }
                          },
                          [_vm._v(_vm._s(page.value))]
                        )
                      ]
                    )
                  ]
            ]
          }),
          _vm._v(" "),
          _c(
            "li",
            {
              class: [
                { "vs-pagination--disabled": _vm.lastPageSelected() },
                {
                  "vs-pagination--no-cursor":
                    !_vm.hidePrevNext && _vm.lastPageSelected()
                }
              ]
            },
            [
              _c(
                "a",
                {
                  attrs: {
                    tabindex:
                      !_vm.hidePrevNext && _vm.lastPageSelected() ? -1 : 0,
                    "aria-label": "Next Page"
                  },
                  on: {
                    click: function($event) {
                      return _vm.moveToPage(true)
                    },
                    keyup: function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      return _vm.moveToPage(true)
                    }
                  }
                },
                [
                  !(_vm.hidePrevNext && _vm.lastPageSelected())
                    ? _vm._t("rightIcon", [
                        _c(
                          "svg",
                          {
                            attrs: {
                              xmlns: "http://www.w3.org/2000/svg",
                              width: "16",
                              height: "16",
                              viewBox: "0 0 16 16",
                              focusable: "false",
                              role: "presentation"
                            }
                          },
                          [
                            _c("path", {
                              attrs: {
                                fill: "currentColor",
                                d:
                                  "M5.61 3.312a.5.5 0 01.718-.69l.062.066 4 5a.5.5 0 01.054.542l-.054.082-4 5a.5.5 0 01-.83-.55l.05-.074L9.359 8l-3.75-4.688z"
                              }
                            })
                          ]
                        )
                      ])
                    : _vm._e()
                ],
                2
              )
            ]
          )
        ],
        2
      )
    ]
  )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  var __vue_inject_styles__ = function (inject) {
    if (!inject) { return }
    inject("data-v-acc4e54e_0", { source: ".vs-pagination {\n  --page-bg-color: #f0f5fb;\n  --page-color: #68737d;\n  --page-active-color: #2f3941;\n  --page-disabled-color: #d8d8d8;\n  padding: 10px 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 0;\n}\n.vs-pagination > li {\n  list-style: none;\n}\n.vs-pagination > li:first-child a {\n  margin-left: 0;\n}\n.vs-pagination > li:last-child a {\n  margin-right: 0;\n}\n.vs-pagination > li > a {\n  min-width: 30px;\n  height: 30px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  text-decoration: none;\n  border-radius: 4px;\n  color: var(--page-color);\n  font-size: 14px;\n  margin-left: 2px;\n  margin-right: 2px;\n  user-select: none;\n}\n.vs-pagination > li > a:hover {\n  background-color: var(--page-bg-color);\n  color: var(--page-active-color);\n}\n.vs-pagination > li > a:focus-visible {\n  box-shadow: 0 0 0 2px rgba(31, 115, 183, 0.35);\n  outline: none;\n}\n.vs-pagination > li.vs-pagination--active a {\n  color: var(--page-active-color);\n  background-color: var(--page-bg-color);\n  font-weight: 600;\n  position: relative;\n  z-index: 1;\n}\n.vs-pagination > li.vs-pagination--disabled > a {\n  color: var(--page-disabled-color) !important;\n  user-select: none;\n  cursor: default;\n}\n.vs-pagination > li.vs-pagination--disabled > a:hover {\n  background: transparent;\n}\n.vs-pagination > li.vs-pagination--disabled.vs-pagination--no-cursor a {\n  cursor: not-allowed;\n}\n.vs-pagination > li.vs-pagination--gap a {\n  cursor: default;\n  color: var(--page-color);\n}\n.vs-pagination > li.vs-pagination--gap a:hover {\n  background: transparent;\n}", map: undefined, media: undefined });

  };
  /* scoped */
  var __vue_scope_id__ = undefined;
  /* module identifier */
  var __vue_module_identifier__ = undefined;
  /* functional template */
  var __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  var __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    createInjector,
    undefined,
    undefined
  );

// Import vue component

// Declare install function executed by Vue.use()
function install(Vue) {
  if (install.installed) { return; }
  install.installed = true;
  Vue.component('VsPagination', __vue_component__);
}

// Create module definition for Vue.use()
var plugin = {
  install: install,
};

// Auto-install when vue is found (eg. in browser via <script> tag)
var GlobalVue = null;
if (typeof window !== 'undefined') {
  GlobalVue = window.Vue;
} else if (typeof global !== 'undefined') {
  GlobalVue = global.Vue;
}
if (GlobalVue) {
  GlobalVue.use(plugin);
}

export default __vue_component__;
export { install };
